import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NoGroupService {

  constructor() { }

  private noGroup : boolean;

  private subject: Subject<boolean> = new Subject<boolean>();

  setNoGroup(noGroup: boolean): void {
    this.noGroup = noGroup;
    this.subject.next(noGroup);
  }

  getNoGroup(): Observable<boolean> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/no-group.service.ts